<template>
  <div
    class="ul-switch d-flex flex-grow-0 rounded"
    :class="{
      success: value && yesNo,
      'grey-lighten': yesNo ? !value : true,
      disabled: disabled,
      'cursor-pointer': !disabled
    }"
    @click.stop="
      () => {
        if (!disabled) {
          $emit('input', !value);
        }
      }
    "
  >
    <div
      class="ul-switch-answer rounded-sm pa-2"
      data-cy="UlSwitchAnswerLeft"
      :class="{ white: !value, 'ul-switch-answer--no': yesNo }"
    >
      <v-icon :color="value ? (yesNo ? 'success' : 'grey-darken-1') : yesNo ? 'error' : 'black'">
        {{ yesNo ? '$cross' : leftIcon }}
      </v-icon>
    </div>
    <div
      class="ul-switch-answer rounded-sm pa-2"
      data-cy="UlSwitchAnswerRight"
      :class="{ white: value, 'ul-switch-answer--yes': yesNo }"
    >
      <v-icon
        :color="value ? (yesNo ? 'success' : 'black') : yesNo ? 'grey-lighten' : 'grey-darken-1'"
      >
        {{ yesNo ? '$tick' : rightIcon }}
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UlSwitch',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      required: true
    },
    yesNo: {
      type: Boolean,
      default: true
    },
    leftIcon: {
      type: String,
      required: false
    },
    rightIcon: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped lang="scss">
.ul-switch {
  cursor: default;
  border: 2 * $border-width solid;

  &.disabled {
    opacity: 0.5;
  }

  .ul-switch-answer {
    &:not(:first-child) {
      margin-left: 2 * $border-width;
    }
  }

  &:not(.disabled) {
    .ul-switch-answer {
      transition: background-color 0.2s map-get($transition, 'ease-in-out');

      &:hover,
      &:focus {
        background-color: rgba($white, 0.5);
      }
    }
  }
}
</style>
